import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/~/react-transition-group/esm/TransitionGroupContext.js
// module id = 471
// module chunks = 118